import socket from "../../../sockets/socket";

const ChatService = {

    register(email, type) {
        socket.emit("register", { email, type });
    },

    pair(adminId, userId) {
        socket.emit("pair", userId);
    },

    sendMessage(message) {
        socket.emit("message", message);
    },

    typing({ adminEmail, userEmail, type }) {
        socket.emit("typing", {
            adminEmail,
            userEmail,
            type
        });
    },

    stopTyping({ adminEmail, userEmail, type }) {
        socket.emit("stopTyping", {
            adminEmail,
            userEmail,
            type
        });
    },

    sendMessageSeen(data) {
        socket.emit("messageSeen", data);
    },

    listenMessageSeen(data) {
        socket.on("messageSeen", data);
    },

    removeMessageSeenListen() {
        socket.off("messageSeen");
    },

    listenMessage(callback) {
        socket.on("message", callback);
    },

    removeMessageListener() {
        socket.off("message");
    },


    listen(event, callback) {
        socket.on(event, callback);
    },

    remove(event) {
        socket.off(event);
    },

    // Connect and register
    connect(email, type) {
        if (!socket.connected) {
            socket.connect();
        }
        console.log("Socket connected manually", email);
        this.register(email, type);
    },

    // Disconnect socket manually
    disconnect() {
        if (socket.connected) {
            socket.disconnect();
            console.log("Socket disconnected manually");
        }
    },

    // Reconnect socket manually
    reconnect(email, type) {
        if (!socket.connected) {
            socket.connect();
            console.log("Socket reconnected manually");
            this.register(email, type); // re-register after reconnect
        }
    },

};

export default ChatService;
